import { Box, LinearProgress, makeStyles } from "@material-ui/core";

interface OverlayProps {
  loading: boolean;
}

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "100%",

      "& .MuiLinearProgress-colorSecondary": {
        color: theme.palette.secondary.main,
        opacity: 0.5,
      },
    },

    content: {
      backgroundColor: theme.palette.common.white,
      opacity: 0.4,
      height: "100%",
    },
  }),
  {
    name: "overlay-style",
    flip: null,
  }
);

export const Overlay = (props: OverlayProps) => {
  const classes = useStyles(props);
  // Props
  const { loading } = props;

  if (loading) {
    return (
      <Box className={classes.root}>
        <LinearProgress color="secondary" value={60} />
        <Box className={classes.content} />
      </Box>
    );
  }

  return <></>;
};
